import { NoteMinusOutlineIcon } from './NoteMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 244AEF5D-38E8-42E6-9C4F-8D4AFF831651
 * name note-minus-outline
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-minus-outline.svg
 * tags
 */
export const StickyNoteMinusOutlineIcon = NoteMinusOutlineIcon;
export default StickyNoteMinusOutlineIcon